import { createAPIError } from "@/services/errors.service";

import type { LoginResponse } from "./auth.service";

const SETUP_REQUIRED_STATUS = "SETUP_REQUIRED";
const UNRECOGNISED_ANSWER_MESSAGE = "The login could not be completed";

type LoginAnswer = {
  token?: unknown;
  requires2FA?: unknown;
  twoFactorToken?: unknown;
  status?: unknown;
  tempToken?: unknown;
  message?: unknown;
};

const asNonEmptyString = (value: unknown): string | undefined =>
  typeof value === "string" && value.length > 0 ? value : undefined;

function refuseAnswer(): never {
  throw createAPIError({ statusCode: 502, message: UNRECOGNISED_ANSWER_MESSAGE });
}

export function parseLoginResponse(answer: unknown): LoginResponse {
  if (typeof answer !== "object" || answer === null) {
    refuseAnswer();
  }

  const { token, requires2FA, twoFactorToken, status, tempToken, message } = answer as LoginAnswer;
  const explanation = asNonEmptyString(message);

  const secondFactorToken = asNonEmptyString(twoFactorToken);
  if (requires2FA === true && secondFactorToken) {
    return { requires2FA: true, twoFactorToken: secondFactorToken, message: explanation };
  }

  const enrollmentToken = asNonEmptyString(tempToken);
  if (status === SETUP_REQUIRED_STATUS && enrollmentToken) {
    return { status: SETUP_REQUIRED_STATUS, tempToken: enrollmentToken, message: explanation };
  }

  const accessToken = asNonEmptyString(token);
  if (accessToken) {
    return { token: accessToken };
  }

  refuseAnswer();
}
